import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import Alert from "../affiliates/Alert";
import ButtonSchedule from "../Buttons/Buttons";
import NextClass from "../TableClass/NextClass";
import TablePlans from "../TablePlans/TablePlans";
import { SCButtonAddInput } from "../Buttons/styles";
import { setButtonBeAffiliatedMenu } from "../../store/slices/affiliate.slice";

const ContentHomeStudent = ({ openSchedule }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { isAffiliate, affiliateInfo } = useSelector((state) => state.affiliateReducer);

  return (
    <div className="contentHomeStudent">
      <div>
        <div className="wrapperAlert">
          {isAffiliate?.length !== 0 && isAffiliate[0] && (
            <Alert
              type=""
              titleButton="BE_AFFILIATED"
              title="REFER_YOUR_FRIENDS_AND_EARN"
              onClick={() => dispatch(setButtonBeAffiliatedMenu(true))}
            />
          )}
          {affiliateInfo?.length !== 0 && (
            <Alert type="affiliate" titleButton="BE_AFFILIATED" title="REFER_YOUR_FRIENDS_AND_EARN" onClick="" />
          )}
        </div>

        <TablePlans />
        <ButtonSchedule justSchedule={false} openSchedule={openSchedule} />

        <div className="nextHome">
          <div className="content">
            <NextClass />
          </div>
        </div>
        <div className="buttonsViewall">
          <Link to={`/calendar/`}>
            <SCButtonAddInput mt="0" ml="auto" mb="0" mr="auto" background="#004fff" color="#fff">
              {t("BTN_VIEW_ALL")}
              <i className="fa fa-angle-right" aria-hidden="true" />
            </SCButtonAddInput>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ContentHomeStudent;
